import { Component, Input, OnInit } from '@angular/core';
import { CASOSEXITOITEM } from '../../interfaces/casos-exito.interface';

@Component({
  selector: 'app-casos-exito-listing-block',
  templateUrl: './casos-exito-listing-block.component.html',
  styleUrls: ['./casos-exito-listing-block.component.css']
})
export class CasosExitoListingBlockComponent implements OnInit {
  img: any;
  @Input() casosExito_item: any = {}

  constructor() { }

  ngOnInit(): void {
    this.img = 'https://' + this.casosExito_item.poster
  }

}
